
import Vue from 'vue'
import Empty from './index.vue'
import Preview from '../preview/index.vue'
export default Vue.extend({
	components:{
		Empty,
		Preview
	}
})
